module.exports = __webpack_public_path__ + "img/admision2027mobile.1424470d.jpg";